import { apiCall } from '../../utils/restclient'
import { GET_ORDER_CANCEL_REASONS_SUCCESS } from './lookupsConstants'

export function getOrderCancelReasons() {
  const endpoint = 'api/v1/lookups?type=ordercancellationreasons'
  try {
    // @ts-expect-error TS2345 TEMP ERROR SUPPRESSION: CRA -> REACT ROUTER
    apiCall(endpoint, 'GET', null, null, {
      success: GET_ORDER_CANCEL_REASONS_SUCCESS,
      error: 'NO_ACTION',
    })
  } catch (e) {
    console.log(e)
  }
}
